// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ujelmxbzazityvhhpvus.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVqZWxteGJ6YXppdHl2aGhwdnVzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1ODk3MjQsImV4cCI6MjA3MTE2NTcyNH0._tkCtPsHlzfHw1-ank25TtuIG5BaHk7hHN-FKdN33Gc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});